import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgbModule, NgbDateAdapter, NgbDateNativeAdapter, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ApiModule, Configuration } from './Api_Module';
import { ChooseListModalComponent } from './views/choose-list-modal/choose-list-modal.component';
import { NavbarComponent } from './views/navbar/navbar.component';
import { ViewbookingsComponent } from './views/viewbookings/viewbookings.component';
import { PagenotfoundComponent } from './views/pagenotfound/pagenotfound.component';
import { ViewreservationsComponent } from './views/viewreservations/viewreservations.component';
import { CustomersComponent } from './views/customers/customers.component';
import { VehicleDetailsComponent } from './views/vehicle-details/vehicle-details.component';
import { NewCustomerDetailsComponent } from './views/customer-details/customer-details.component';
import { CreateCustomerModalComponent } from './views/createCustomerModal/create-customer-modal.component';
import { CreateBookingModalComponent } from './views/createBookingModal/create-booking-modal.component';
import { CheckOutBookingModalComponent } from './views/checkOutBookingModal/checkout-booking-modal.component';
import { UserLoginComponent } from './views/user-login/user-login.component';
import { HomeComponent } from './views/home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { JwtInterceptor } from './Api_Module/interceptors/jwt.interceptor';
import { ErrorInterceptor } from './Api_Module/interceptors/error.interceptor';
import { environment } from '../environments/environment';
import { SearchbookingsComponent } from './views/searchbookings/searchbookings.component';
import { UsersComponent } from './views/users/users.component';
import { AuthenticationService } from './services/authentication.service';
import { CreateVehicleModalComponent } from './views/createVehicleModal/create-vehicle-modal.component';
import { UserPasswordResetModalComponent } from './views/userPasswordModal/user-password-modal.component';
import { ComfirmModalComponent } from './views/comfirm-modal/comfirm-modal.component';
import { AngenciesComponent } from './views/agencies/agencies.component';
import { CreateAgencyModalComponent } from './views/createAgencyModal/create-agency-modal.component';
import { CreateAgentModalComponent } from './views/createAgentModal/create-agent-modal.component';
import { CreateUserModalComponent } from './views/create-user-modal/create-user-modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { LandingPageComponent } from './views/landing-page/landing-page.component';
import { ReportsComponent } from './views/reports/reports.component';
import { LoadingInterceptor } from './Api_Module/interceptors/loading.interceptor';
import { SettingsComponent } from './views/settings/settings.component';
import { SettingsModalComponent } from './views/settings-modal/settings-modal.component';
import { RegisterComponent } from './views/user-register/register.component';
import { AdminDashComponent } from './views/home/admin-dash/admin-dash.component';
import { CustomerDashComponent } from './views/home/customer-dash/customer-dash.component';
import { AgentDashComponent } from './views/home/agent-dash/agent-dash.component';
import { NoWhitespaceDirective } from './directives/no-whitespace.directive';
import { EqualValidator } from './directives/PasswordEqual.directive';
import { UpdateAgencyCreditsModalComponent } from './views/update-agency-credits-modal/update-agency-credits-modal.component';
import { InvoiceComponent } from './views/invoice/invoice.component';
import { TermsComponent } from './views/terms/terms.component';
import { DirectionsComponent } from './views/directions/directions.component';
import { ResetComponent } from './views/reset/reset.component';
import { UserPasswordComponent } from './views/user-password/user-password.component';
import { Globals } from './globals';
import { ContactUsComponent } from './views/contact-us/contact-us.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    CreateBookingModalComponent,
    ViewbookingsComponent,
    PagenotfoundComponent,
    UserLoginComponent,
    ViewreservationsComponent,
    CreateCustomerModalComponent,
    CustomersComponent,
    VehicleDetailsComponent,
    NewCustomerDetailsComponent,
    CheckOutBookingModalComponent,
    UserLoginComponent,
    HomeComponent,
    SearchbookingsComponent,
    UsersComponent,
    CreateVehicleModalComponent,
    UserPasswordResetModalComponent,
    ComfirmModalComponent,
    AngenciesComponent,
    CreateAgencyModalComponent,
    CreateAgentModalComponent,
    CreateUserModalComponent,
    LandingPageComponent,
    ReportsComponent,
    SettingsComponent,
    SettingsModalComponent,
    RegisterComponent,
    AdminDashComponent,
    CustomerDashComponent,
    ChooseListModalComponent,
    AgentDashComponent,
    NoWhitespaceDirective,
    EqualValidator,
    UpdateAgencyCreditsModalComponent,
    InvoiceComponent,
    TermsComponent,
    DirectionsComponent,
    ResetComponent,
    UserPasswordComponent,
    ContactUsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CommonModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    Ng4LoadingSpinnerModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    ApiModule.forRoot(getApiConfig),
    NgbModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgxDatatableModule
  ],
  providers: [
    {provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},
    AuthGuard,
    Globals,
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export const apiConfig = new Configuration({
  basePath: environment.apiBase,
  withCredentials: false
});
export function getApiConfig() {
  return apiConfig;
}
